import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { store } from 'redux-rest-reducer';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { Separator, Row, Button } from '@cuemath/comps';
import { withRouter } from 'react-router';

import { get as getListCount } from 'actions/list-count';
import { getAll as getStudentDemoList } from 'actions/student-demo-list';
import { openModal } from 'actions/modal';

import StudentDemoList from 'screens/batch-assignment/student-demos/list';
import { RESOURCE_URL } from 'constants/api';
import { STUDENT_PER_PAGE, TABLE_TYPE } from 'constants/list';
import { FORM_ACTIONS, MODAL_FORM, MODAL_TYPE } from 'constants/form';
import MODAL from 'constants/modal';

const Head = styled(Row)`
  width: 100%;
  padding-left: 15px;
  padding-right: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const ButtonWrapper = styled(Button)`
  margin: 0 20px;
`;

class StudentListForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      searchKey: null,
      listData: null,
      countData: null,
      studentId: null,
      studentPatch: store.patch(),
      filterParam: null,
    };
  }

  static propTypes = {
    studentProfileInfo: PropTypes.object,
    studentId: PropTypes.string,
    toggleRMEnabled: PropTypes.bool.isRequired,
  };

  static getDerivedStateFromProps(props, { page, listData }) {
    const { studentDemoList, studentId } = props;

    const listParams = {
      page,
      per_page: STUDENT_PER_PAGE,
      student_id: studentId,
      action: 'get',
      include_recent_class_id: true,
    };

    const newState = {};

    const listDataGet = store.getAll(studentDemoList, listParams);

    if (listDataGet && listDataGet.isLoaded) {
      newState.listData = listDataGet;
    }
    return newState;
  }

  getStudentDemoParamsFilters = () => {
    const { studentId } = this.props;
    const { page } = this.state;

    return {
      listParams: {
        page,
        per_page: STUDENT_PER_PAGE,
        student_id: studentId,
        action: 'get',
        include_recent_class_id: true,
      },
      filterData: {
        page,
        per_page: STUDENT_PER_PAGE,
        student_id: studentId,
        action: 'get',
        include_recent_class_id: true,
      },
    };
  };

  getCountFilters = () => {
    const { studentId } = this.props;
    const { page } = this.state;

    return {
      count: true,
      page,
      per_page: STUDENT_PER_PAGE,
      action: 'count',
      student_id: studentId,
    };
  };

  componentDidMount() {
    const {
      studentProfileInfo: { demos },
    } = this.props;
    this.setState({ listData: { data: demos } });
  }

  getStudentDemoData = (prevProps, prevState, forceStale = false) => {
    const { actions } = this.props;
    const { listData, filterParam } = this.state;
    const { listParams, filterData } = this.getStudentDemoParamsFilters();
    const countFilterParams = this.getCountFilters();

    const countParams = { count: true };

    const isListStale = !!(listData && listData.isStale);

    if (
      (prevState && filterParam !== prevState.filterParam) ||
      isListStale ||
      forceStale
    ) {
      if (filterParam) {
        filterParam.forEach(filter => {
          let value = filter.value;
          const key = filter.id;

          if (value && Array.isArray(value) && value.length) {
            filterData[key] = value;
            countFilterParams[key] = value;
          } else {
            if (value !== null) {
              filterData[key] = value;
              countFilterParams[key] = value;
            }
          }
        });
      }
      actions.getStudentDemoList(listParams, filterData);
      actions.getListCount(RESOURCE_URL.studentdemos, countParams, countFilterParams);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    this.getStudentDemoData(prevProps, prevState);
  }

  markStateAndGetStudentDemo = () => {
    this.getStudentDemoData(null, null, true);
  };

  onUpdateDemo = studentData => {
    const { actions, studentProfileInfo } = this.props;
    const { is_plus_lead: isPlusLead } = studentProfileInfo || {};
    actions.openModal(
      MODAL_FORM.UPDATE_DEMO,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 40) / 100)}px`,
        height: MODAL.UPDATE_HEIGHT,
      },
      {
        formType: FORM_ACTIONS.EDIT,
        data: {
          ...studentData,
          isPlusLead,
        },
        modalType: MODAL_TYPE.UPDATE,
        getStudentDemoData: this.markStateAndGetStudentDemo,
      },
    );
  };

  onToggleRMCall = (isPlusLead, studentData) => {
    const { actions } = this.props;

    actions.openModal(
      MODAL_FORM.UPDATE_DEMO,
      {},
      {
        formType: FORM_ACTIONS.EDIT,
        data: { isPlusLead, ...studentData },
        modalType: MODAL_TYPE.TOGGLE_RM_CALL,
        getStudentDemoData: this.markStateAndGetStudentDemo,
      },
    );
  };

  onDisableTeacher = studentData => {
    const { actions } = this.props;
    actions.openModal(
      MODAL_FORM.UPDATE_DEMO,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 40) / 100)}px`,
        height: MODAL.UPDATE_HEIGHT,
      },
      {
        formType: FORM_ACTIONS.EDIT,
        data: studentData,
        modalType: MODAL_TYPE.DISABLE,
        getStudentDemoData: this.markStateAndGetStudentDemo,
      },
    );
  };

  onFilter = filters => {
    this.setState({ filterParam: filters });
  };

  onDemoBook = studentData => {
    const { actions, studentProfileInfo: student, programs } = this.props;

    actions.openModal(
      MODAL_FORM.ASSIGN_TEACHER,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
        height: MODAL.UPDATE_HEIGHT,
      },
      {
        formType: FORM_ACTIONS.CREATE,
        data: {
          ...student,
        },
        programs,
      },
    );
  };

  render() {
    const { listData } = this.state;
    const { studentProfileInfo, toggleRMEnabled } = this.props;
    const { is_plus_lead: isPlusLead } = studentProfileInfo || {};

    return (
      <React.Fragment>
        <Separator transparent height="10" />
        <Head>
          <ButtonWrapper label="Create demo with teacher" onClick={this.onDemoBook} />
        </Head>
        <Separator transparent height="10" />
        <StudentDemoList
          isPlusLead={isPlusLead}
          tableData={listData && listData.data ? listData.data : []}
          onFilter={this.onFilter}
          countData={listData && listData.data ? listData.data.length : 0}
          tableType={TABLE_TYPE.parent}
          defaultPageSize={5}
          onUpdateDemo={this.onUpdateDemo}
          onToggleRMCall={this.onToggleRMCall}
          onDisableTeacher={this.onDisableTeacher}
          style={{ height: 300, textAlign: 'center' }}
          toggleRMEnabled={toggleRMEnabled}
        />
      </React.Fragment>
    );
  }
}

export default withRouter(
  connect(
    (
      { studentDemoList, listCount, studentProfile },
      { match: { params: { demo } = {} } = {} },
    ) => ({
      demo,
      studentDemoList,
      studentProfile,
      listCount,
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getStudentDemoList,
          getListCount,
          openModal,
        },
        dispatch,
      ),
    }),
  )(StudentListForm),
);
